import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";
import { ExternalProps } from "constants/external";

const FormDate = () => (
  <ComponentDocs
    name="<Form.Date/>"
    entry="DateField"
    propsEntry="DateProps"
    namespace="FormFields"
    externalProps={ExternalProps.MuiDatePicker}
  >
    <ComponentExample
      name="Local date"
      description="A local date represents a date that is local to the user's timezone, where no time element is required."
      import={import("examples/Forms/FormDate/LocalDateExample")}
      rawImport={import("examples/Forms/FormDate/LocalDateExample?raw")}
    />
    <ComponentExample
      name="Instant date"
      description="An instant date represents a point in time that can be globally agreed on, in the form of an ISO8601 UTC string."
      import={import("examples/Forms/FormDate/InstantDateExample")}
      rawImport={import("examples/Forms/FormDate/InstantDateExample?raw")}
    />
    <ComponentExample
      name="Date ranges"
      description="Two date fields can define a range of dates using the rangeBoundary and rangeField props."
      import={import("examples/Forms/FormDate/DateRangesExample")}
      rawImport={import("examples/Forms/FormDate/DateRangesExample?raw")}
    />
    <ComponentExample
      name="Restricted dates"
      import={import("examples/Forms/FormDate/RestrictedDatesExample")}
      rawImport={import("examples/Forms/FormDate/RestrictedDatesExample?raw")}
    />
  </ComponentDocs>
);

export default FormDate;
